/* Native Shopify accessory variants; ACO does not submit these configurations. */
(() => {
  let adding = false;
  const route = path => `${window.Shopify?.routes?.root || '/'}${path}`;
  const sections = 'cart-items,cart-footer,cart-item-count,cart-live-region';

  async function add(form, button) {
    if (adding) return;
    adding = true;
    button?.setAttribute('aria-busy', 'true');
    const root = document.querySelector('[data-ak-posters-product="true"]');
    let error = root.querySelector('[data-ak-native-cart-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.akNativeCartError = '';
      error.setAttribute('role', 'alert');
      error.style.cssText = 'position:fixed;bottom:110px;left:50%;transform:translateX(-50%);z-index:9999;background:var(--ak-wall);color:#000;padding:12px;max-width:90vw';
      root.append(error);
    }
    error.textContent = '';
    error.hidden = true;
    try {
      const quantity = Number(form ? new FormData(form).get('quantity') || 1 : 1);
      if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Please choose a valid quantity.');
      const items = await window.akBuildPosterCartItems(quantity);
      const response = await fetch(route('cart/add.js'), {
        method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
        body:JSON.stringify({items, sections, sections_url:location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add your artwork.');
      document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem', {
        bubbles:true, detail:{response:data, sourceId:form?.getAttribute('id') || 'ak-native-poster'}
      }));
      window.dispatchEvent(new CustomEvent('ak-open-cart'));
    } catch (failure) {
      error.textContent = failure.message;
      error.hidden = false;
      document.dispatchEvent(new CustomEvent('theme:product:error:add-to-cart', {
        detail:{formEl:form, productRootEl:root, message:failure.message, errors:failure.message}
      }));
    } finally {
      adding = false;
      button?.removeAttribute('aria-busy');
    }
  }

  // Capture before the options app's document/form handlers. Only Posters
  // purchase buttons use this path; all other product forms remain untouched.
  window.addEventListener('click', event => {
    const button = event.target.closest?.('[data-ak-posters-product="true"] :is(button.add-to-cart, button[name="add"], .ak-mobile-basket-trigger)');
    if (!button || button.disabled || !window.akBuildPosterCartItems) return;
    const form = button.form || button.closest('form');
    event.preventDefault();
    event.stopImmediatePropagation();
    add(form, button);
  }, true);
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!form.closest?.('[data-ak-posters-product="true"]') || !window.akBuildPosterCartItems) return;
    if (!new URL(form.action, location.origin).pathname.endsWith('/cart/add')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    add(form, event.submitter);
  }, true);

  // Update every component in one request when the customer changes the
  // configuration's quantity or removes it from either cart view.
  window.akChangeConfiguredCart = async (key, quantity, request) => {
    const row = Array.from(document.querySelectorAll('[data-line-item-key]'))
      .find(element => element.dataset.lineItemKey === key);
    if (!row?.dataset.akConfiguration) return fetch(window.theme.routes.cart_change_url, request);
    const cartResponse = await fetch(route('cart.js'), {headers:{Accept:'application/json'}});
    if (!cartResponse.ok) throw new Error('Could not load your cart.');
    const cart = await cartResponse.json();
    const group = cart.items.find(item => item.key === key)?.properties?._ak_configuration;
    if (!group) throw new Error('Your cart changed. Please refresh it.');
    const updates = {};
    cart.items.filter(item => item.properties?._ak_configuration === group)
      .forEach(item => { updates[item.key] = quantity; });
    return fetch(route('cart/update.js'), {
      ...request, body:JSON.stringify({updates, sections, sections_url:location.pathname})
    });
  };
})();
